import React from 'react'
import AppConstantService from '../../services/AppConstantService';
import { useParams, useNavigate } from "react-router-dom";
import { Edit } from 'react-admin';
import { Box, Grid, TextField } from '@mui/material';
import CircularLoader from '../Common/CircularLoader';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from '../Common/CustomSnackBar';

let appConstantService = new AppConstantService();
function EditAppConstant() {
    const { id } = useParams<{ id: string }>();
    let [loading, setLoading] = React.useState<boolean>(false);
    let [appConstantData, setAppConstantData] = React.useState<any>(null);
    let [error, setError] = React.useState<string | null>(null);
    let navigate = useNavigate();

    React.useEffect(() => {
        setLoading(true);
        appConstantService.fetchAppConstantById(Number(id)).then((response: any) => {
            setAppConstantData(response?.data);
            setError(null);
        }).catch((error: any) => {
            console.error("Error fetching App Constant:", error);
            setError("Failed to fetch App Constant");
        }).finally(() => {
            setLoading(false);
        });   
    }, [id]);


    const handleSubmit = () => {
        if (!appConstantData?.name || !appConstantData?.value) {
            setError("Name and Value cannot be empty");
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Missing Data",
                type: CustomSnackbarTypes.ERROR,
            });
            return;
        }
        setLoading(true);
        appConstantService.updateAppConstant(Number(id), appConstantData).then((response: any) => {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Updated Successfully",
                type: CustomSnackbarTypes.SUCCESS,
            });
            setAppConstantData(null);
            setError(null);
            navigate(`/AppConstants/${response?.id}/show`, {replace: true});
        }).catch((error: any) => {
            console.error("Error updating App Constant:", error);
            setError("Failed to update App Constant");
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                type: CustomSnackbarTypes.ERROR,
            });
        }).finally(() => {
            setLoading(false);
        });
    };
  return (
    <div>
        {loading && <CircularLoader/>}
        {error && <div style={{ color: 'red' }}>{error}</div>}
        {appConstantData && (
            <Edit title={'Edit App Constant'} resource="AppConstants" id={id}>
            <Box
                sx={{
                padding: "12px",
                }}
            >
                <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                    label="Name"
                    value={appConstantData.name}
                    onChange={(e) => setAppConstantData({ ...appConstantData, name: e.target.value })}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                    minRows={10}
                    value={appConstantData.value}
                    multiline
                    fullWidth
                    onChange={(e) => setAppConstantData({ ...appConstantData, value: e.target.value })}
                    />
                </Grid>
                <Grid item xs={12}>
                    <button onClick={handleSubmit} style={{ padding: '8px 16px', backgroundColor: '#3f51b5', color: 'white', border: 'none', borderRadius: '4px' }}>
                    Save
                    </button>
                </Grid>    
                </Grid>
            </Box>
            </Edit>
        )}

      
    </div>
  )
}

export default EditAppConstant
